<template>
  <div class="document-selection-page">
    <h1>{{ $t('heading.documentSelectionPage-' + this.$route.params.materialType) }}</h1>
    <div class="table-limit">
      <label for="limit">{{ $t('label.showResultsPerPage') }}</label>
      <select @change="switchPage(limit, offset)" v-model="limit" name="limit" id="limit">
        <option value="10">10</option>
        <option value="20">20</option>
        <option value="50">50</option>
        <option value="100">100</option>
      </select>
    </div>
    <table-pagination v-if="count" :count="parseInt(count)" :limit="parseInt(limit)" :offset="parseInt(offset)" @created="switchPage" @switch-page="switchPage"></table-pagination>
    <loading-overlay v-if="loading"></loading-overlay>
    <md-table v-if="documents && !loading" v-model="documents">
      <md-table-row slot="md-table-row" slot-scope="{ item }">
        <md-table-cell :md-label="$t('label.document')" md-sort-by="document_key">{{ item.label + ' - ' + item.title }}</md-table-cell>
        <md-table-cell :md-label="$t('label.displayedInService')">
          <md-radio v-model="item.selectedByEditor" @change="handleSelectionChange(item)" :value="true"></md-radio>
        </md-table-cell>
        <md-table-cell :md-label="$t('label.notDisplayedInService')">
          <md-radio v-model="item.selectedByEditor" @change="handleSelectionChange(item)" :value="false"></md-radio>
        </md-table-cell>
        <md-table-cell :md-label="$t('label.default')">
          <md-radio v-model="item.selectedByEditor" @change="handleSelectionChange(item)" :value="null">{{ item.preselected ? $t('label.displayedInService') : $t('label.notDisplayedInService') }}</md-radio>
        </md-table-cell>
      </md-table-row>
    </md-table>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import LoadingOverlay from './LoadingOverlay'
import TablePagination from './TablePagination'

export default {
  name: 'DocumentSelectionPage',
  data () {
    return {
      limit: parseInt(this.$route.query.limit),
      offset: parseInt(this.$route.query.offset)
    }
  },
  components: {
    LoadingOverlay,
    TablePagination
  },
  computed: {
    ...mapState({
      account: state => state.account.account,
      count: state => parseInt(state.documents.count),
      documents: state => state.documents.items,
      loading: state => state.documents.loading
    })
  },
  created () {
    const { limit, offset } = this
    this.switchPage({ limit, offset })
  },
  methods: {
    handleSelectionChange (item) {
      const { module, language, documentKey, selectedByEditor, materialType } = item
      this.updateDocumentSelectedByEditor({ module, language, documentKey, materialType, selectedByEditor })
    },
    switchPage ({ limit, offset }) {
      this.offset = offset
      const { language, materialType } = this.$route.params
      this.$router.push(this.$route.path + `?limit=${limit}&offset=${offset}`).catch(() => {})
      this.getDocumentCount({ module: this.account.module, language, materialType })
      this.getAllDocuments({ module: this.account.module, language, materialType, limit, offset })
    },
    ...mapActions('documents', {
      getDocumentCount: 'getCount',
      getAllDocuments: 'getAll',
      updateDocumentSelectedByEditor: 'updateSelectedByEditor'
    })
  }
}
</script>

<style scoped>
.md-table {
  text-align: left;
}
.table-limit {
  text-align: right;
  margin-right: 10px;
}
</style>
